import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { ImportExport } from "./ImportExport";

export const importExport = typeCheckAppModule({
    NAME,
    Container: ImportExport,
});
